const files = require.context('./', false, /\.png$/)
const images = {}
files.keys().forEach(path => { images[path.replace('./', '').replace('.png', '')] = files(path) })

const aliases = {
  'arsenal':['阿森纳','兵工厂','Arsenal'],
  'manchester-city':['曼城','曼彻斯特城','Manchester City','Man City'],
  'manchester-united':['曼联','曼彻斯特联','Manchester United','Man United'],
  'liverpool':['利物浦','Liverpool'], 'chelsea':['切尔西','Chelsea'],
  'tottenham':['热刺','托特纳姆热刺','Tottenham','Spurs'],
  'newcastle':['纽卡斯尔','纽卡斯尔联','Newcastle'], 'aston-villa':['阿斯顿维拉','维拉','Aston Villa'],
  'real-madrid':['皇家马德里','皇马','Real Madrid'], 'barcelona':['巴塞罗那','巴萨','Barcelona'],
  'atletico-madrid':['马德里竞技','马竞','Atletico Madrid','Atlético Madrid'],
  'sevilla':['塞维利亚','Sevilla'], 'athletic-bilbao':['毕尔巴鄂竞技','毕尔巴鄂','Athletic Bilbao'],
  'real-sociedad':['皇家社会','Real Sociedad'], 'villarreal':['比利亚雷亚尔','维拉利尔','Villarreal'],
  'bayern-munich':['拜仁慕尼黑','拜仁','Bayern Munich','Bayern München'],
  'borussia-dortmund':['多特蒙德','Dortmund','Borussia Dortmund'],
  'bayer-leverkusen':['勒沃库森','Leverkusen','Bayer Leverkusen'],
  'rb-leipzig':['莱比锡红牛','RB莱比锡','RB Leipzig'], 'eintracht-frankfurt':['法兰克福','Frankfurt','Eintracht Frankfurt'],
  'inter-milan':['国际米兰','国米','Inter Milan','Internazionale'], 'ac-milan':['AC米兰','米兰','AC Milan'],
  'juventus':['尤文图斯','尤文','Juventus'], 'napoli':['那不勒斯','Napoli'], 'roma':['罗马','Roma'],
  'lazio':['拉齐奥','Lazio'], 'atalanta':['亚特兰大','Atalanta'],
  'paris-saint-germain':['巴黎圣日耳曼','巴黎','PSG','Paris Saint-Germain'],
  'marseille':['马赛','Marseille'], 'monaco':['摩纳哥','Monaco'], 'lyon':['里昂','Lyon'], 'lille':['里尔','Lille'],
  'benfica':['本菲卡','宾菲加','Benfica'], 'porto':['波尔图','波图','Porto'],
  'sporting-lisbon':['葡萄牙体育','里斯本竞技','Sporting Lisbon','Sporting CP'],
  'ajax':['阿贾克斯','Ajax'], 'psv':['埃因霍温','PSV'], 'feyenoord':['费耶诺德','Feyenoord']
}

function normalize(value){
  return String(value || '').toLowerCase().replace(/[\s·.()（）\-_]/g, '').replace(/足球俱乐部|俱乐部|footballclub|fc/g, '')
}

const aliasIndex = {}
Object.keys(aliases).forEach(slug => aliases[slug].forEach(name => { aliasIndex[normalize(name)] = images[slug] }))

export function findTeamLogo(name){
  const key = normalize(name)
  if(aliasIndex[key]) return aliasIndex[key]
  const matched = Object.keys(aliasIndex).find(alias => key.includes(alias) || alias.includes(key))
  return matched ? aliasIndex[matched] : ''
}

export const teamLogoCount = Object.keys(images).length
